export default __webpack_public_path__ + "static/media/Saving.1f00485d.png";